Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    bp = _STYLES$useStyles.bp;
  var leaderboardPointsValue = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.l,
    lineHeight: _styles.STYLES.lineHeight.l,
    color: colors.brand
  });
  if (bp.mobile_xl) {
    leaderboardPointsValue.fontSize = _styles.STYLES.fontSize.m;
    leaderboardPointsValue.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var leaderboardPointsValueUnit = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.l,
    color: colors.brand
  });
  if (bp.mobile_xl) {
    leaderboardPointsValueUnit.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var styles = _reactNative.StyleSheet.create({
    leaderboardPointsValue: leaderboardPointsValue,
    leaderboardPointsValueUnit: leaderboardPointsValueUnit
  });
  return {
    styles: styles
  };
};